import {
  CURRENT_MODAL,
  ACTIVITY_DETAILS,
  LOADING,
  QUERY_DETAILS,
  LOAD_LOCATIONS,
  SHOW_SEARCH_RESULT,
  LIST_CATEGORIES,
  ROOT,
  API_PATH,
  MEMBER_DETAILS,
  SET_OTP,
  USER_DETAILS,
  USER_DATA,
  USER_ID,
  USER_PHONE,
  BUTTON_LOADER,
  RESET_OTP,
  SET_PASSWORD
} from "./constants";

export function loading(bool) {
  return {
    type: LOADING,
    payload: bool
  };
}

export function loadCategories(category) {
  return {
    type: LIST_CATEGORIES,
    payload: category
  };
}
export function updateCurrentModal(modal) {
  return {
    type: CURRENT_MODAL,
    payload: modal
  };
}

export function updateQueryDetails(queryType, id, dateType, startDate, endDate, category) {
  return {
    type: QUERY_DETAILS,
    payload: { queryType, id, dateType, startDate, endDate, category }
  };
}

export function setActivityDetails(id, name) {
  return {
    type: ACTIVITY_DETAILS,
    payload: { id: id, name: name }
  };
}
export function storeQueryDetails(queryType, id, dateType, startDate, endDate, category) {
  return dispatch => {
    dispatch(updateQueryDetails(queryType, id, dateType, startDate, endDate, category));
  };
}

export function storeLocationSearchResult(data) {
  return {
    type: LOAD_LOCATIONS,
    payload: data
  };
}

export function showSearchResult(bool) {
  return {
    type: SHOW_SEARCH_RESULT,
    payload: bool
  };
}

export function updateMemberDetails(adPax, chPax, comment) {
  return {
    type: MEMBER_DETAILS,
    payload: { adPax, chPax, comment }
  };
}
export function updateUserDetails(name, email, phone) {
  return {
    type: USER_DETAILS,
    payload: { name, email, phone }
  };
}

export function setOTP(code) {
  return {
    type: SET_OTP,
    payload: code
  };
}
export function resetOTP() {
  return {
    type: RESET_OTP
  };
}

export function setUserData(user) {
  return {
    type: USER_DATA,
    payload: user
  };
}
export function setUserId(id) {
  return {
    type: USER_ID,
    payload: id
  };
}

export function setUserPhone(phone, countryCode) {
  return {
    type: USER_PHONE,
    payload: { phone, countryCode }
  };
}

export function buttonLoader(bool) {
  return {
    type: BUTTON_LOADER,
    payload: bool
  };
}
export function setPassword(pass) {
  return {
    type: SET_PASSWORD,
    payload: pass
  };
}
export function searchDetination(dest) {
  let url = ROOT + "ajax/vendors/activity/suggestLocation.php?term=";

  return dispatch => {
    return fetch(url + dest)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(data) {
        dispatch(showSearchResult(true));
        return dispatch(storeLocationSearchResult(data));
      })
      .catch(function(error) {
        console.log(error);
      });
  };
}

export function fetchCategoryList() {
  let url = API_PATH + "getCategories.php";
  return dispatch => {
    dispatch(showSearchResult(false));
    return fetch(url)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(data) {
        if (data.status) return dispatch(loadCategories(data.payload));
      })
      .catch(function(error) {
        console.log(error);
      });
  };
}

export function sendOTP(phone, countryCode) {
  let url = API_PATH + "sendOTPToNumber.php";
  let data = new FormData();
  data.append("number", phone);
  data.append("countryCode", countryCode);
  return dispatch => {
    dispatch(buttonLoader(true));
    return fetch(url, {
      method: "POST",
      body: data
    })
      .then(checkStatus)
      .then(parseJSON)
      .then(function(data) {
        if (data.registered) {
          dispatch(setUserId(parseInt(data.registered, 10)));
        } else {
          dispatch(setUserId(data.registered));
        }
        dispatch(setUserPhone(phone, countryCode));
        dispatch(buttonLoader(false));
        dispatch(setOTP(data.code));
        return dispatch(updateCurrentModal("VERIFY_OTP"));
      })
      .catch(function(error) {
        console.log(error);
      });
  };
}

export function getUserData(id) {
  let url = API_PATH + "getUserData.php";
  let data = new FormData();
  if (id) data.append("id", id);

  return dispatch => {
    return fetch(url, {
      method: "POST",
      body: data,
      credentials: "same-origin"
    })
      .then(checkStatus)
      .then(parseJSON)
      .then(function(data) {
        if (data.status) {
          return dispatch(setUserData({ ...data.payload, login: true }));
        } else {
          return dispatch(
            setUserData({
              id: false,
              name: "",
              email: "",
              phone: "",
              phone_verified: "no",
              countryCode: "",
              login: false
            })
          );
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };
}

export function getUserDataById(id) {
  let url = API_PATH + "getUserDataById.php";
  let data = new FormData();
  data.append("id", id);

  return dispatch => {
    dispatch(buttonLoader(true));
    return fetch(url, { method: "POST", body: data, credentials: "same-origin" })
      .then(checkStatus)
      .then(parseJSON)
      .then(function(data) {
        if (data.status) {
          dispatch(setUserData(data.payload));
        } else {
          dispatch(setUserData({ id: false, name: "", email: "", phone: "", phone_verified: "no", countryCode: "" }));
        }
        dispatch(buttonLoader(false));
        return dispatch(updateCurrentModal("ASK_USER_DETAILS"));
      })
      .catch(function(error) {
        console.log(error);
      });
  };
}

export function registerEnquiry(id, first_name, last_name, email, phone, all, countryCode) {
  let url = API_PATH + "registerEnquiry_new.php";
  let data = new FormData();
  data.append("source", all.activityDetails.id);
  data.append("first_name", first_name);
  data.append("last_name", last_name);
  data.append("email", email);
  data.append("phone", phone);
  data.append("countryCode", countryCode);

  if (id) {
    data.append("user_id", id);
  }

  data.append("dateType", all.queryDetails.dateType);
  data.append("startDate", all.queryDetails.startDate);
  data.append("endDate", all.queryDetails.endDate);
  data.append("queryType", all.queryDetails.queryType);
  data.append("id", all.queryDetails.id);
  data.append("nrAdults", all.memberDetails.adPax);
  data.append("nrChild", all.memberDetails.chPax);
  data.append("comment", all.memberDetails.comment);
  data.append("category", all.queryDetails.category);

  return dispatch => {
    dispatch(buttonLoader(true));
    return fetch(url, {
      method: "POST",
      body: data,
      credentials: "same-origin"
    })
      .then(checkStatus)
      .then(parseJSON)
      .then(function(data) {
        dispatch(buttonLoader(false));
        return dispatch(updateCurrentModal("THANK_YOU"));
      })
      .catch(function(error) {
        console.log(error);
      });
  };
}

export function register_user(phone, country_code, password) {
  let url = API_PATH + "register_user.php";
  let data = new FormData();

  data.append("phone", phone);
  data.append("countryCode", country_code);
  data.append("password", password);

  return dispatch => {
    dispatch(buttonLoader(true));
    return fetch(url, { method: "POST", body: data, credentials: "same-origin" })
      .then(checkStatus)
      .then(parseJSON)
      .then(function(data) {
        if (data.status) {
          dispatch(setUserId(data.id));
          dispatch(setUserPhone(phone, country_code));
          dispatch(buttonLoader(false));
          return dispatch(updateCurrentModal("ASK_USER_DETAILS"));
        } else {
          console.log(data.error);
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };
}
export function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

export function parseJSON(response) {
  return response.json();
}
